module.exports = __webpack_public_path__ + "img/normal-big.5a34c428.svg";